import './assets/global.css';
import 'fieldConfig';

import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { createGenerateClassName } from '@material-ui/core/styles';
import { clubeBlackTheme, theme } from 'assets/theme';
import Dialogs from 'components/Dialogs';
import AppRouter from 'components/Router';
import Alert from 'components/Shared/Alert';
import ColorPicker from 'components/Shared/ColorPicker';
import Loader from 'components/Shared/Loader';
import Snackbar from 'components/Shared/Snackbar';
import React from 'react';
import JssProvider from 'react-jss/lib/JssProvider';
import baseRoutes from 'routes';
import { setup } from 'rxjs-operators';
import { setPixel } from 'services/pixel';
import { ENV } from 'settings';
import authService from 'services/auth';
import hotjarService from 'services/hotjarService';
import { ThemeProvider } from '@material-ui/styles';

interface IState {
  useClubeBlackTheme?: boolean;
}

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true,
  productionPrefix: 'sun-'
});

class App extends React.PureComponent<{}, IState> {
  loader: Loader;

  constructor(props: {}) {
    super(props);
    this.state = { useClubeBlackTheme: false };
  }

  componentDidMount() {
    setup(this.loader);

    hotjarService.init();
    if (ENV === 'production') {
      setPixel();
    }

    authService.isClubeBlack().subscribe(isClubeBlack => {
      this.setState({ useClubeBlackTheme: isClubeBlack });
    });
  }

  render() {
    const { useClubeBlackTheme } = this.state;

    return (
      <JssProvider generateClassName={generateClassName}>
        <ThemeProvider theme={useClubeBlackTheme ? clubeBlackTheme : theme}>
          <MuiThemeProvider theme={useClubeBlackTheme ? clubeBlackTheme : theme}>
            <CssBaseline />
            <Dialogs />
            <ColorPicker />
            <Loader ref={ref => (this.loader = ref)} />

            <Alert.Global />
            <Snackbar.Global />

            <AppRouter routes={baseRoutes} />
          </MuiThemeProvider>
        </ThemeProvider>
      </JssProvider>
    );
  }
}

export default App;
